import { api } from './api.client'
import type { User, LoginRequest, RegisterRequest } from '@/types/user.types'

export const authService = {
  login: (credentials: LoginRequest) =>
    api.post<{ user: User }>('/auth/login', credentials),

  register: (data: RegisterRequest) =>
    api.post<{ user: User; message: string }>('/auth/register', data),

  refresh: () =>
    api.post<{ user: User }>('/auth/refresh', {}),

  getProfile: () =>
    api.get<User>('/users/me'),

  updateProfile: (patch: Partial<Pick<User, 'firstName' | 'lastName' | 'location' | 'avatar'>>) =>
    api.patch<User>('/users/me', patch),

  updatePassword: (payload: { currentPassword: string; newPassword: string }) =>
    api.post<void>('/auth/password', payload),

  logout: () =>
    api.post<void>('/auth/logout', {}),
}
